module.exports = __webpack_public_path__ + "static/media/SCR007.430e10a4.wav";